import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Start invoice (resume from stop) - Admin Invoice Management
 * @param {string|number} invoiceId - The invoice id
 * @param {string} comment - Optional comment
 * @returns {Promise} - API response
 */
export const startInvoice = async (invoiceId, comment = '') => {
  try {
    const response = await apiClient.post(
      `/adminInvoiceManagement/invoice/by-id/${invoiceId}/start`,
      { comment }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

/**
 * Stop invoice - Admin Invoice Management
 * @param {string|number} invoiceId - The invoice id
 * @param {string} comment - Optional comment
 * @returns {Promise} - API response
 */
export const stopInvoice = async (invoiceId, comment = '') => {
  try {
    const response = await apiClient.post(
      `/adminInvoiceManagement/invoice/by-id/${invoiceId}/stop`,
      {
        comment,
      }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

/**
 * Reject invoice (Admin Invoice Management) - pending_rejection flow
 * @param {string|number} invoiceId - The invoice id
 * @param {string} reasonOfRejection - Required reason
 * @param {string} comment - Optional comment
 * @returns {Promise} - API response
 */
export const rejectInvoice = async (invoiceId, reasonOfRejection, comment = '') => {
  try {
    const response = await apiClient.post(
      `/adminInvoiceManagement/invoice/by-id/${invoiceId}/reject`,
      { comment, reason_of_rejection: reasonOfRejection }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
